import * as api from '@owl-nest/api-client/next'
import * as auth from '@owl-nest/auth'
// TODO: clean this when we remove the update function from auth, and don't forget to remove the import into package.json

export async function sendResetPasswordRequest(email: string): Promise<api.HttpResult> {
  const response = await api.client('POST /users/password-reset', {
    body: {
      email,
    },
  })

  return response.next((success) => {
    return success.body
  })
}

export function updatePassword(userId: number, password: string, passwordConfirmation: string, token: string) {
  return auth.update(
    userId,
    {
      password,
      password_confirmation: passwordConfirmation,
    },
    token,
  )
}
